import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import type { Element as HastElement, ElementContent } from 'hast';
import { MermaidBlock } from './MermaidBlock';

/** If this <pre> wraps a ```mermaid fence, return the chart source. */
function mermaidChart(node: HastElement | undefined): string | null {
  const child = node?.children?.[0];
  if (!child || child.type !== 'element' || child.tagName !== 'code') return null;
  const className = child.properties?.className;
  if (!Array.isArray(className) || !className.includes('language-mermaid')) return null;
  return child.children
    .map((c: ElementContent) => (c.type === 'text' ? c.value : ''))
    .join('');
}

/** Renders a markdown string with GFM support inside our prose styling. */
export function Markdown({
  children,
  className = '',
}: {
  children: string;
  className?: string;
}) {
  return (
    <div className={`prose-aiai ${className}`}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          a: ({ node: _node, ...props }) => (
            <a {...props} target="_blank" rel="noreferrer noopener" />
          ),
          table: ({ node: _node, ...props }) => (
            <div className="overflow-x-auto">
              <table {...props} />
            </div>
          ),
          pre: ({ node, ...props }) => {
            const chart = mermaidChart(node);
            if (chart !== null) return <MermaidBlock chart={chart} />;
            return <pre {...props} />;
          },
        }}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
}
